import React from "react";
import "./IPR.css";
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from "../about/PageHeader";

const IPR = () => {
  return (
    <>
      <Navbar />
      <PageHeader
        title="Intellectual Property Rights (IPR)"
        crumbs={[{ label: "Home", href: "/" }, { label: "Intellectual Property Rights (IPR)" }]}
      />
      <div className="iprM-wrapper">

        <div className="iprM-container">

          {/* ABOUT */}
          <div className="iprM-card">
            <h2>About IPR Cell</h2>

            <p>
              Intellectual Property Rights is an inevitable tool for today’s globalized economy. 
              Fostering innovation is one of the sustainable development goals set by the Government of India. 
              TIMSCDR has established IPR cell with following objectives:
            </p>

            <h3>Objectives</h3>

            <ul className="iprM-list">
              <li>To create an awareness about IPR for faculties and students & to stimulate generation of IPR</li>
              <li>To conduct workshops, seminars and training course on IPR</li>
              <li>To protect the rights of authors, innovators, research scholars</li>
              <li>To encourage faculty members and scholars to go for patentable works</li>
            </ul>

            <p className="iprM-muted">
              The IPR Cell at TIMSCDR has a Committee of experts from inter-disciplinary domains. 
              The IPR Cell consists of the following members:
            </p>
          </div>

          {/* COMMITTEE */}
          <div className="iprM-card">
            <h2>IPR Cell Committee</h2>

            <table className="iprM-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Name</th>
                  <th>Designation</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>1</td><td>Prof. Sonu Gupta</td><td>Dy. Director</td></tr>
                <tr><td>2</td><td>Mr. Dnyaneshwar Kamble</td><td>Industry Delegate</td></tr>
                <tr><td>3</td><td>Dr. Padma Mishra</td><td>Associate Professor</td></tr>
                <tr><td>4</td><td>Mr. Shirshendu Maitra</td><td>HoD Academics, MCA</td></tr>
                <tr><td>5</td><td>Ms. Mira Gohil</td><td>Assistant Professor</td></tr>
              </tbody>
            </table>
          </div>

          {/* COPYRIGHT */}
<div className="iprM-card">
            <h2>Copyright Registrations</h2>
            <p className="iprM-muted">Following literary work is registered for Copyright :</p>

            <div className="iprM-listCard">“Mentorship Handbook”, Registration no. L-70301/2017.</div>
            <div className="iprM-listCard">“Faculty Handbook”, Registration no. L-77960/2018.</div>
            <div className="iprM-listCard">“Digital Presence of a Doctor”, Registration no. L-76954/2018.</div>
            <div className="iprM-listCard">“Optimizing Healthcare-SEO”, Registration no. L-93405/2020.</div>
            <div className="iprM-listCard">“Virtual Clinic – COVID-19 Scenario" (Diary No: 29695/2021-CO/L)</div>

            <div className="iprM-listCard iprM-flex">
              <span>“Healthcare on Cloud" (Diary No:19405/2024-CO/L)</span>
              <a href="/pdf/RD/IPR/View Document.pdf" target="_blank" rel="noopener noreferrer">
                <button className="iprM-btn">View Document</button>
              </a>
            </div>
          </div>

          {/* PATENTS */}
<div className="iprM-card">
            <h2>Patent registered of the Institute</h2>

            <div className="iprM-listCard iprM-flex">
              <span>Indian Patent – “IoT based Crowd Detection System in City Buses”, Application No. 202221033373, Filed on 10/06/2022 and published on 01/07/2022.</span>
              <a href="/pdf/RD/IPR/View Document 2.pdf" target="_blank" rel="noopener noreferrer">
                <button className="iprM-btn">View Document</button>
              </a>
            </div>

            <div className="iprM-listCard iprM-flex">
              <span>Indian Patent – “Helmet 2.0: The Tech Helmet with Smart Features and Helmet based Vehicle Electronic Safety System”, Application No. 202221064089, Filed on 09/11/2022 and published on 18/11/2022.</span>
              <a href="/pdf/RD/IPR/View Document 3.pdf" target="_blank" rel="noopener noreferrer">
                <button className="iprM-btn">View Document</button>
              </a>
            </div>

            <div className="iprM-listCard iprM-flex">
              <span>Indian Patent Application 202421037643 A, titled “Integrating IoT to Ensure Health Safety by Evaluating Physical, Chemical, and Biological Water Quality Parameters for Safe Drinking Water in Rural Communities”, was filed on 13 May 2024 and published on 24 May 2024.</span>
              <a href="/pdf/RD/IPR/View Document 4.pdf" target="_blank" rel="noopener noreferrer">
                <button className="iprM-btn">View Document</button>
              </a>
            </div>

            <div className="iprM-listCard iprM-flex">
              <span>Design Patent for IoT-Based Water Quality Testing Apparatus (Application No. 456412-001, CBR No. 208719) filed on 24/04/2025 — Examination Report generated and online reply received on 25/07/2025.</span>
              <a href="/pdf/RD/IPR/View Document 5.pdf" target="_blank" rel="noopener noreferrer">
                <button className="iprM-btn">View Document</button>
              </a>
            </div>

            <div className="iprM-listCard iprM-flex">
              <span>Certificate of Registration of Design issued by the Patent Office, Government of India for “IoT Based Water Quality Testing Apparatus” (Design No. 456412-001, dated 24/04/2025). Registered in the names of Thakur Institute of Management Studies, Career Development & Research and the listed inventors; Date of Issue: 05/12/2025.</span>
              <a href="/pdf/RD/IPR/View Document 6.pdf" target="_blank" rel="noopener noreferrer">
                <button className="iprM-btn">View Document</button>
              </a>
            </div>

          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default IPR;